import type { ProjectApi } from 'api-typings/projects/projects';
import type { AllProjectsContext } from '../all-projects';
import { transformAllProjects } from '../all-projects';
import { transformDisplayedLocation } from '../project-view-projects/project-view-projects.transformers';
import { transformLocation } from '../users/users-location.transformers';
import type { SuperUserAllProjects } from './superuser-project-view-all-projects.model';

export function transformSuperUserAllProjects(
  project: ProjectApi,
  context: AllProjectsContext,
): SuperUserAllProjects {
  return {
    ...transformAllProjects(project, context),
    location: project.location
      ? transformLocation(project.location)
      : undefined,
    trueLocation: project.true_location
      ? transformLocation(project.true_location)
      : undefined,
    displayLocation: transformDisplayedLocation(
      project.true_location || project.location,
    ),
  };
}
